import { useRouter } from '@moonpig/web-core-routing'
import { useEffect } from 'react'
import { useSearchStore } from '../store/SearchStore'

export const useResetOffset = (offset: number) => {
  const { onRouteChangeStart } = useRouter()
  const resetInitialOffset = useSearchStore(store => store.resetInitialOffset)
  const initialOffsetFromStore = useSearchStore(store => store.initialOffset)

  useEffect(
    () =>
      onRouteChangeStart(() => {
        if (offset !== initialOffsetFromStore) {
          resetInitialOffset()
        }
      }),
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [onRouteChangeStart],
  )
}
